import { Component, Input } from "@angular/core";
import { RoadworkCitsState } from "src/app/models";

/** The different types of roadwork states. */
export enum StateType {
	Cits,
	Bms,
}

/**
 * Shows a chip based on the supplied roadwork state information.
 */
@Component({
	selector: "dr-state-chip[state][displayTextTranslation][cssClass]",
	templateUrl: "./state-chip.component.html",
	styleUrls: ["./state-chip.component.scss"],
})
export class StateChipComponent {
	/** The supplied state. */
	@Input() public state!: RoadworkCitsState;
	/** The translation string of the text in the chip. Available from the roadwork class. */
	@Input() public displayTextTranslation!: string;
	/** The CssClass to set the chip color. Available from the roadwork class. */
	@Input() public cssClass!: string;

	public readonly stateType = StateType;
}
